import React from 'react';

// Components
import InputWrapperLabel from './components/InputWrapperLabel';

interface Props {
  label?: string;
  error?: React.ReactNode;
  isMandatory?: boolean;
  children?: React.ReactNode;
  className?: string;
}

const InputWrapper: React.FC<Props> = ({ label, error, isMandatory, children, className = '' }) => {
  return (
    <div className={`input-wrapper ${className || ''}`}>
      <InputWrapperLabel label={label} isMandatory={isMandatory} />
      {children}

      {error && <span className="input-wrapper__error">{error}</span>}
    </div>
  );
};

export default InputWrapper;
